import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  fullWidth?: boolean;
}
export const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  href,
  className = '',
  fullWidth = false
}) => {
  const handleClick = () => {
    if (onClick) onClick();
    if (href) {
      window.location.href = href;
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`
        relative group overflow-hidden rounded-sm
        bg-gold text-navy-900 font-serif font-bold text-lg md:text-xl tracking-wide
        px-8 py-4 shadow-[0_0_20px_rgba(201,169,97,0.3)]
        transition-all duration-300 hover:shadow-[0_0_30px_rgba(212,175,55,0.5)]
        hover:bg-gold-light
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-22">
      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-23">
        {children}
      </span>
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-24" />
    </motion.button>;
};